import React from 'react';
import './SectionTag.css';

export default function SectionTag({ children }) {
  return <div className="section-tag">{children}</div>;
}
